import { applyMiddleware, compose, createStore } from 'redux';
import { persistStore } from 'redux-persist';
import thunk from 'redux-thunk';

import dealApi from 'modules/Deal/api/deal';
import dispatchingApi from 'modules/Event/api/dispatching';
import serviceCallApi from 'modules/ServiceCall/api/serviceCall';
import taskApi from 'modules/Task/api/task';
import officeApi from 'modules/Office/api/office';
import { registerWorkOrderNotesSync } from 'modules/ServiceCall/workOrderNotesSync';

// eslint-disable-next-line import/no-cycle
import rootReducer from './combineReducers';
import listenerMiddleware from './listenerMiddleware';

registerWorkOrderNotesSync(listenerMiddleware);

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const customMiddleware = (store) => (next) => (action) => next(action);

export const store = createStore(
  rootReducer,
  composeEnhancers(
    applyMiddleware(
      listenerMiddleware.middleware,
      thunk,
      customMiddleware,
      dispatchingApi.middleware,
      serviceCallApi.middleware,
      taskApi.middleware,
      dealApi.middleware,
      officeApi.middleware,
    ),
  ),
);

export const testStore = (preloadedState) =>
  createStore(
    rootReducer,
    preloadedState,
    composeEnhancers(
      applyMiddleware(
        listenerMiddleware.middleware,
        thunk,
        customMiddleware,
        dispatchingApi.middleware,
        serviceCallApi.middleware,
        taskApi.middleware,
        dealApi.middleware,
        officeApi.middleware,
      ),
    ),
  );

export const persistor = persistStore(store);
